export default {
  itens(state) {
    return state.itens;
  },
  tipos(state) {
    return state.tipos;
  },
  tipo(state) {
    return state.tipo;
  }
};
